import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as simulator from './simulator';
import * as tios from './tios';

export default class Tibbit_35 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_35';
        this.name = 'Tibbit 35';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];

        const settings = [
            {
                id: 'PRESSURE_NAME',
                name: 'Pressure Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);

        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt35/tbt35.tbh',
            'libraries/tibbits/tbt35/tbt35.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
